import { render } from "./FoldersListComponent.vue?vue&type=template&id=471c3d31&ts=true"
import script from "./FoldersListComponent.vue?vue&type=script&lang=ts"
export * from "./FoldersListComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__